var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClaimBtnHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 57,
    viewBox: "0 0 216 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 17C1 13.134 4.13401 10 8 10H208C211.866 10 215 13.134 215 17V49C215 52.866 211.866 56 208 56H8C4.134 56 1 52.866 1 49V17Z",
    fill: "#0087C0",
    stroke: "#156688",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8C1 4.13401 4.13401 1 8 1H208C211.866 1 215 4.13401 215 8V40C215 43.866 211.866 47 208 47H8C4.134 47 1 43.866 1 40V8Z",
    fill: "#16A0D9",
    stroke: "#156688",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimBtnHover);
export default __webpack_public_path__ + "static/media/claimBtn-hover.418d9d525a151e626f7cd831ac09578b.svg";
export { ForwardRef as ReactComponent };